import React from 'react';

interface TruncateProps {
  text: string;
  maxLength: number;
}

const truncateString = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + '...';
};

const TruncateText: React.FC<TruncateProps> = ({ text, maxLength }) => {
  const truncatedText = truncateString(text, maxLength);

  return <span>{truncatedText}</span>;
};

export default TruncateText;
